module.exports = __webpack_public_path__ + "static/img/company.7e97e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.png
// module id = NeCJ
// module chunks = 1